import { scrollToElement } from '@cian/newbuilding-utils';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { setHash } from 'shared/utils/setHash';

import styles from './PikLogo.css';

export const PikLogo: FC = () => {
  const handleLogoClick = useCallback((event: SyntheticEvent) => {
    event.preventDefault();

    setHash('');
    scrollToElement({ selector: 'body' });
  }, []);

  return (
    <a className={styles['container']} href="#" onClick={handleLogoClick}>
      <img alt="ПИК" height={16} src="https://static.cdn-cian.ru/media/images/pik_orange.svg" width={54} />
    </a>
  );
};
